var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.53 9.32-8.125-7.6c-.494-.463-.742-.694-1.024-.782a1.286 1.286 0 0 0-.762 0c-.282.088-.53.32-1.024.782L2.47 9.32C1.326 10.392.754 10.927.695 11.387c-.055.437.116.871.455 1.152.357.296 1.14.296 2.707.296v6.172c0 1.44 0 2.16.28 2.71.247.484.64.877 1.124 1.123.55.28 1.28.28 2.74.28.729 0 1.093 0 1.369-.14.241-.123.438-.32.561-.561.14-.275.14-.635.14-1.355v-4.586a1.929 1.929 0 0 1 3.858 0v4.586c0 .72 0 1.08.14 1.355.123.242.32.438.562.562.275.14.64.14 1.37.14 1.458 0 2.188 0 2.738-.28.484-.247.877-.64 1.124-1.124.28-.55.28-1.27.28-2.71v-6.172c1.567 0 2.35 0 2.707-.296.339-.28.51-.715.455-1.152-.059-.46-.63-.995-1.775-2.065Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome24);
export default __webpack_public_path__ + "static/media/home_24.a0436c68.svg";
export { ForwardRef as ReactComponent };